import { IAge } from "pages/FolderManagement/components/LeftPanel/filters/AgeRange";
import { IContactInfo } from "pages/FolderManagement/components/LeftPanel/filters/ContactInfo";
import { IContactedBy } from "pages/FolderManagement/components/LeftPanel/filters/ContactedBy";
import { ICompany } from "pages/FolderManagement/components/LeftPanel/filters/CurrentCompany";
import { IJob } from "pages/FolderManagement/components/LeftPanel/filters/CurrentJobTitle";
import { IExperience } from "pages/FolderManagement/components/LeftPanel/filters/Experience";
import {
  IFunction,
  IRole,
} from "pages/FolderManagement/components/LeftPanel/filters/FunctionsAndRoles";
import {
  IIndustryOption,
  ISkillsOption,
} from "pages/FolderManagement/components/LeftPanel/filters/Industry";
import { ILocation } from "pages/FolderManagement/components/LeftPanel/filters/Location";
import { IResponseType } from "pages/FolderManagement/components/LeftPanel/filters/ResponseType";
import { ISalary } from "pages/FolderManagement/components/LeftPanel/filters/Salary";
import { IShortListedBy } from "pages/FolderManagement/components/LeftPanel/filters/ShortlistedBy";
import { IEmailCampaign } from "pages/FolderManagement/components/LeftPanel/filters/EmailCampaign";
import { IDateRange } from "pages/FolderManagement/components/LeftPanel/filters/DatePicker/DateList";
import { IWhatsappCampaign } from "@/pages/FolderManagement/components/LeftPanel/filters/WhatsappCampaign";

export interface IFilterFormValues {
  sort_by_profile_ranking_score:string;
  industry: IIndustryOption[];
  "Good To Have Skills": string[];
  "Must Have Skills": string[];
  "onlyTop": boolean;
      "onlyNonExported": boolean;
  cpc: string;
  ipi: string | number;
  location: ILocation;
  age: IAge;
  experience: IExperience;
  contactedBy: IContactedBy[];
  contactInfo: IContactInfo[];
  emailCampaign: IEmailCampaign[];
  whatsappCampaign: IWhatsappCampaign[];
  shortlistedBy: IShortListedBy[];
  responseType: IResponseType[];
  currentState: number[];
  salary: ISalary;
  functions: IFunction[];
  roles: IRole[];
  jobs: IJob[];
  companies: ICompany[];
  downloadStatus: string;
  gender: string;
  query: string;
  shortlistedWithin: IDateRange;
  contactedWithin: IDateRange;
  is_preferred_designations?: boolean;
  designations?: string[];
  designation_categories?: string[];
  designations_scope?: string;
}

export const filterFormValues: IFilterFormValues = (() => {
  return {
    cpc: "pc",
    sort_by_profile_ranking_score:"relevance",
    "Good To Have Skills": [],
    "Must Have Skills": [],
    "onlyTop": false,
    "onlyNonExported": false,
    ipi: 0,
    industry: [],
    location: {
      current: [],
      preferred: [],
      show: false,
    },
    age: { min: undefined, max: undefined },
    experience: {
      months: { min: undefined, max: undefined },
      years: { min: undefined, max: undefined },
    },
    contactedBy: [],
    contactInfo: [],
    emailCampaign: [],
    whatsappCampaign: [],
    shortlistedBy: [],
    responseType: [],
    salary: { min: undefined, max: undefined },
    functions: [],
    roles: [],
    jobs: [],
    companies: [],
    downloadStatus: "both",
    currentState: [0],
    gender: "any",
    query: "",
    shortlistedWithin: {
      value: undefined,
      startDate: undefined,
      endDate: undefined,
    },
    contactedWithin: {
      value: undefined,
      startDate: undefined,
      endDate: undefined,
    },
    is_preferred_designations: false,
    designations: [],
    designation_categories: [],
    designations_scope: "c",
  };
})();
